import { render } from "./EditorActions.vue?vue&type=template&id=55c3988e"
import script from "./EditorActions.vue?vue&type=script&lang=js"
export * from "./EditorActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__